import React, { useState } from "react"
import Welcome from '../views/Welcome/Welcome'
import { useNavigate, useLocation } from "react-router-dom"

const PrivateRoute = (daata) =>{
    let token = JSON.parse(localStorage.getItem("TOKEN"));
    let tokenSession = JSON.parse(sessionStorage.getItem("TOKEN_SESSION"));
    const navigate = useNavigate()
    const location = useLocation()

    if(!token || token == null){
        navigate('/'+localStorage.getItem("spajHash"))
        return <Welcome/>
    }
    if(!tokenSession || tokenSession == null){
        // if(location.pathname.toLowerCase() != "/pembayaran"){
        //     navigate('/:id')
        //     return <Welcome/>
        // }else{
            sessionStorage.setItem("TOKEN_SESSION",localStorage.getItem("TOKEN"));
        // }
    }
    return daata.children
}

export default PrivateRoute